<header>
  <div  class="header-wrapper">
    <!-- Logo and product title -->
    <div class="header-left" 
         tabindex="0"  
         (click)="goToHomePage()" 
         (keyup.enter)="goToHomePage()" 
         role="link">
      <img  class="tdm-logo" src=" ../../assets/images/TDM_logo.svg" title="Text Data Mining Studio Logo"/>
      <div class="product-title">
        <p class="proquest-label">ProQuest</p>
        <h1 class="studio-title" title="Text and Data Mining Studio">TDM Studio</h1>
      </div>
    </div>

    <!-- Site navigation links -->
    <div *ngIf="showDashboardLinks()" role="tablist" aria-label="Dashboard Navigation" class="links" role="navigation">
      <!-- workbench dashboard link -->
      <div [ngClass]="isWorkbench ? 'selected site-nav' : 'site-nav large-screen'" 
          (click)="goToWorkbench()" 
          (keyup.enter)="goToWorkbench()"
          role="tab" 
          tabindex="0" 
          [attr.aria-selected]="isWorkbench">
        <img class="icon" 
            src="../../../assets/images/Flexible_new.svg" 
            alt="">
        <span>Workbench</span>
      </div>

      <!-- isRequest Access modal window-->
      <div  class="request-access-modal" 
            *ngIf="isRequestAccess" 
            role="dialog" aria-modal="true" 
            aria-labelledby="request-header" 
            aria-describedby="request-content">

        <h1 class="modal-header" id="request-header">Activation Request</h1>
        <div>
          <p class="modal-content" id="request-content">Your institution can activate your workbench.
            Would you like to request activation?</p>
          <div class="button-bar">
            <a [href]="LINKS.REQUEST_WORKBENCH_ACCESS"><div class="request-button">Send Request</div></a>
            <div class="link" tabindex="0" (click)="isRequestAccess = false" (keyup.enter)="isRequestAccess = false" aria-label="cancel link">Cancel</div>
          </div>
        </div>
      </div>

      <!-- Visualization dashboard link -->
      <div [ngClass]="isAnalysis ? 'selected site-nav' : 'site-nav large-screen'" 
            (click)="goToAnalysis()" (keyup.enter)="goToAnalysis()"
            role="tab" 
            tabindex="0" 
            [attr.aria-selected]="isAnalysis">
        <img class="icon" src="../../../assets/images/Viz-icon.svg" alt="">
        <span>Visualization</span>
      </div>

      <!-- Help & Learn toolbar link -->
      <div class="site-nav large-screen" tabindex="0" *ngIf="isAnalysis || isWorkbench" 
          (click)="openHelpWindow()"
          (keyup.enter)="openHelpWindow()"
          role="tab">
        <span class="bi-question-circle"></span>
        <span class="help-learn">Help & Learn</span>
      </div>

    </div>

    <!-- Right panel -->
    <div class="user-header-right" role="navigation"  aria-label="main menu">
      <div class="contact-us-container">      
        <div #contactDetails>
          <div  class="contact-nav"  
                tabindex="0" 
                role="button"
                [attr.aria-expanded]="isContactDetailsVisible"
                (click)="toggleContactDetails()"
                (keyup.enter)="toggleContactDetails()">
            Contact Us
          </div>
          <div class="contact-details" *ngIf="isContactDetailsVisible">
              <p class="product-questions-lbl">Product Questions</p>
              <p >Email us at <a href="mailto:tdmstudio@clarivate.com">tdmstudio&#64;clarivate.com</a></p>
          </div>
        </div>
      </div>
      <!-- User is not logged in -->
      <div *ngIf="!isUser" class="login" tabindex="0" (click)="auth.login()" (keyup.enter)="auth.login()" role="link">Log In</div>

      <a *ngIf="!isUser" href="/createaccount" class="create-account"> Create Account </a>

      <a *ngIf="!isUser" class="login" [href]="LINKS.TDMS_TRIAL" role="link" target="_blank" rel="noopener">Free Trial</a>

      <!-- User is logged in -->
      <p *ngIf="isUser" class="email">{{ tdmUser?.email }}</p>  
      <div *ngIf="isUser" class="logout large-screen" (click)="auth.logout()" (keyup.enter)="auth.logout()" tabindex="0" role="link">Logout</div>
    

      <!-- Small screen menu icon -->
      <mat-icon
        fontSet="material-symbols-outlined"
        class="menu-icon small-screen"
        role="menu"
        aria-label="Navigation Menu"
        (click)="isDropdownMenu = !isDropdownMenu"
        (keyup.enter)="isDropdownMenu = !isDropdownMenu"
        tabindex="0">
        menu
      </mat-icon>

      <div class="menu-dropdown" *ngIf="isDropdownMenu">

        <div *ngIf="!isWorkbench" class="menu-nav" (click)="goToWorkbench()" (keyup.enter)="goToWorkbench()" tabindex="0" role="link">
            <img class="icon" src="../../../assets/images/Flexible_new.svg" alt="Workbench icon">
            <span>Workbench</span>
        </div>

        <div *ngIf="!isAnalysis" class="menu-nav" (click)="goToAnalysis()" (keyup.enter)="goToAnalysis()" tabindex="0" role="link">
          <img class="icon" src="../../../assets/images/Viz-icon.svg" alt="Visualization icon">
          <span>Visualization</span>
        </div>

        <div class="menu-nav" tabindex="0" *ngIf="isAnalysis || isWorkbench" (click)="openHelpWindow()" (keyup.enter)="openHelpWindow()" role="link">
            <span class="bi-question-circle"></span>
            <span class="help-learn">Help & Learn</span>
        </div>

        <div class="menu-nav" (click)="auth.logout(); this.isDropdownMenu = false;" (keyup.enter)="auth.logout(); this.isDropdownMenu = false;" tabindex="0" role="link">Logout</div>

      </div>
    </div>
  </div>
</header>

<div>
	<tdms-onbording-banner (closeOnBoard)="onCloseOnBoardEvent($event)" *ngIf="displayOnboard"></tdms-onbording-banner>
</div>